export default {
    reprocess_odometer_hours_title: "Reprocesar Odometros/Horas de Motor",
    reprocess_odometer_hours_account: "Cuenta",
    reprocess_odometer_hours_devices: "Dispositivos",
    reprocess_odometer_hours_input: "IMEI o serie",
    reprocess_odometer_hours_imei: "IMEI",
    reprocess_odometer_hours_serial: "Serie",
    reprocess_odometer_hours_model: "Modelo",
    reprocess_odometer_hours_all: "Todos los dispositivos",
    reprocess_odometer_hours_specific: "Dispositivos especificos",
    reprocess_odometer_hours_start_reprocess: "Iniciar Reproceso",
    reprocess_odometer_hours_reprocess_date: "Fecha Reproceso",
    reprocess_odometer_hours_devices_to_reprocess: "Dispositivos a Reprocesar:",
    reprocess_odometer_hours_selected_date: "Fecha Seleccionada:",
    reprocess_odometer_hours_message: "El estado del reproceso se puede seguir en la sección de transacciones",
    reprocess_odometer_hours_success_message: "El reproceso se ha registrado, clíc aquí para ver el estado",
    reprocess_odometer_hours_error_message: "No se ha podido registrar el reproceso debido a un error",
    reprocess_odometer_hours_device_is_already_added: "El dispositivo ya está añadido",
    reprocess_odometer_hours_device_has_not_been_found: "No se ha encontrado el dispositivo",
    reprocess_odometer_hours_high_init_message: "¿Esta seguro que desean enviar",
    reprocess_odometer_hours_devices_message: "dispositivos a reprocesar? esto podría causar un gran esfuerzo en nuestro sistema",
    reprocess_odometer_hours_date_range_message: "meses a reprocesar? esto podría causar un gran esfuerzo en nuestro sistema",
    reprocess_odometer_hours_devices: "dispositivos",
    reprocess_odometer_hours_and: "y",
    reprocess_odometer_hours_months: "meses a reprocesar? esto podría causar un gran esfuerzo en nuestro sistema",
    reprocess_odometer_hours_type: "Tipo de reproceso de agregaciones",
    reprocess_odometer_hours_type_update: "Actualizar",
    reprocess_odometer_hours_type_rebuild: "Reconstruir",
    reprocess_odometer_hours_devices_mode: "Dispositivos a reprocesar",
    reprocess_odometer_hours_no_units_found: "No hay unidades disponibles para esta cuenta",

}